import React from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { CellProps } from "../types";

type StatusValue = "draft" | "active" | "paused";

const statusConfig: Record<StatusValue, { label: string; className: string }> = {
  draft: {
    label: "Draft",
    className: "bg-muted text-muted-foreground hover:bg-muted",
  },
  active: {
    label: "Active",
    className: "bg-green-500/20 text-green-400 hover:bg-green-500/30",
  },
  paused: {
    label: "Paused",
    className: "bg-yellow-500/20 text-yellow-400 hover:bg-yellow-500/30",
  },
};

export function StatusCell({ value, onChange }: CellProps<StatusValue>) {
  const config = statusConfig[value] || statusConfig.draft;

  const handleClick = () => {
    // Toggle between active and paused (draft stays as draft until explicitly changed)
    if (value === "active") {
      onChange("paused");
    } else if (value === "paused") {
      onChange("active");
    }
    // draft status doesn't toggle via click
  };

  return (
    <Badge
      variant="secondary"
      className={cn(
        "text-xs font-medium cursor-pointer select-none transition-colors",
        config.className
      )}
      onClick={handleClick}
    >
      {config.label}
    </Badge>
  );
}
